
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-701.008 -794.034)","fill":"#222"}},[_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(707.008 800.034)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(707.008 815.514)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(707.008 830.91)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(722.469 800.034)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(722.469 815.514)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(722.469 830.91)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(737.928 800.034)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(737.928 815.514)"}}),_c('ellipse',{attrs:{"cx":"4.994","cy":"4.974","rx":"4.994","ry":"4.974","transform":"translate(737.928 830.91)"}})])])
          )
        }
      }
    